//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";
import DialogTipsView from "./dialog_tips_view";

@ccclass
@moduleInit("dialogtips")
export default class DialogTips extends ModuleBase<DialogTipsView, null> {

    enterCallback: Function
    closeCallback: Function
    hideCallback : Function
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/dialog_tips";
        this.viewType = DialogTipsView;
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    /**
     * 
     * @param intentData  有titleError字段标题图片为"错误",否则为"提示"
     */
    onShow(intentData) {
        if (intentData.Content != null){
            this.view.showTips(intentData.Content)
        }
        
        if (intentData.EnterCallBack != null){
            //this.enterCallback = intentData.EnterCallBack
            this.view.ShowStyle(1);
        }
        //隐藏取消按钮 确认按钮居中
        else{
            this.view.ShowStyle(2);
        }
        this.enterCallback = intentData.EnterCallBack

        //if (intentData.CloseCallBack != null){
            this.closeCallback = intentData.CloseCallBack
        //}

        //if (intentData.HideCallBack != null){
            this.hideCallback = intentData.HideCallBack
        //}

        if (intentData.titleError) {
            this.view.ShowTitleStyle(2);
        }else{
            this.view.ShowTitleStyle(1);
        }
    }

    protected onButtonClickName(name : string) {
        switch (name) {
            case "CancelBtn":
                this.hide()
                if (this.closeCallback != null) { this.closeCallback() }
                break
            case "ConfimBtn":
                this.hide()
                if (this.enterCallback != null) { this.enterCallback() }
                break
            case "CloseBtn":
                this.hide()
                if (this.hideCallback != null) { this.hideCallback() }
                break;
            default:
                break
        }
    }


    onDisable() {
        this.unscheduleAllCallbacks()
    }

    onDestroy() {
        this.unscheduleAllCallbacks()
    }
}